export default __webpack_public_path__ + "static/winter43-9a05a6209e3fa9fe6cba81f3dc3725d7.webp";